/*
 * @Descripttion:
 * @version:
 * @Author: shp
 * @Date: 2021-11-30 11:13:57
 * @LastEditors: shp
 * @LastEditTime: 2021-11-30 15:39:57
 */
var merge = require("webpack-merge");

module.exports = merge(
  {},
  {
    NODE_ENV: '"production"',
    GOODWILL_HOST: "https://crmgoodwill.porsche-dealer-platform.com",
  },
  {
    NODE_ENV: '"production"',
    MODIFYPASS_HOST: "http://redemption-gateway.porsche-dealer-platform.com",
  },
  {
    NODE_ENV: '"production"',
    REFERRALPLATFORM_HOST: "https://referral.porsche.cn",
  },
  {
    NODE_ENV: '"production"',
    GIFT_HOST: "https://pdms.porsche-pcn.com",
  },
  {
    NODE_ENV: '"production"',
    ETMT_HOST: "https://www.porsche-etmt.com.cn",
  },
  {
    NODE_ENV: '"production"',
    PORSCHECLUB_HOST: "https://gate.porsche.cn/cm-community-service",
  },
  {
    NODE_ENV: '"production"',
    CM_PORTAL_HOST: "https://crm-award.porsche-dealer-platform.com/cm/portal/web",
  }
);



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 5